import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = ['what-time-is-it'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      whatTimeIsItRetrieve: build.query<
        WhatTimeIsItRetrieveApiResponse,
        WhatTimeIsItRetrieveApiArg
      >({
        query: () => ({ url: `/what-time-is-it/` }),
        providesTags: ['what-time-is-it'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bambiApi };
export type WhatTimeIsItRetrieveApiResponse = /** status 200  */ ServerTime;
export type WhatTimeIsItRetrieveApiArg = void;
export type ServerTime = {
  server_time: string;
  org_timezone: string;
};
export type ClientErrorEnum = 'client_error';
export type ParseErrorCodeEnum = 'parse_error';
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type WhatTimeIsItRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ErrorCode404Enum = 'not_found';
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export const {
  useWhatTimeIsItRetrieveQuery,
  useLazyWhatTimeIsItRetrieveQuery,
} = injectedRtkApi;
